import React from 'react'

import classnames from 'classnames'

import { Card, CardContent, Skeleton } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => {
  const classList = {

    card: {
      margin: theme.spacing(2, 1),
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%'
      },
      maxWidth: `calc(50% - ${theme.spacing(2)})`,
      width: '100%'
    },

    fullWidth: {
      maxWidth: '100%',
      width: '100%'
    },

    cardHeader: {
      display: 'grid',
      transform: 'translateY(-55px)',
      marginBottom: -50,
      alignItems: 'center',
      gridTemplateColumns: '90px 1fr',
      [theme.breakpoints.only('xs')]: {
        gridTemplateColumns: '70px 1fr'
      }
    },

    cardMedia: {
      height: 120,
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    },
    cardLogo: {
      zIndex: 2,
      width: 80,
      height: 80,
      bottom: 0,
      left: 32,
      borderRadius: '50%',
      overflow: 'hidden',
      backgroundColor: 'white',
      border: '2px solid #fff',
      boxShadow: 'rgba(0,0,0,0.2) 0px 2px 8px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.only('xs')]: {
        width: 60,
        height: 60
      },
      '& img': {
        [theme.breakpoints.only('xs')]: {
          maxWidth: 55,
          maxHeight: 55
        },
        maxWidth: 75,
        maxHeight: 75
      }

    },
    footer: {
      color: 'rgb(118, 118, 118)',
      fontSize: 14,
      letterSpacing: '0ch',
      textTransform: 'none',
      padding: 0,
      display: 'flex',
      flexDirection: 'row',
      gap: 4,
      justifyContent: 'space-evenly',

      '& > div': {
        flexBasis: '100%',
        padding: theme.spacing(1, 0)
      },

      '& .start': {
        textAlign: 'start'
      },
      '& .center': {
        textAlign: 'center'
      },
      '& .end': {
        textAlign: 'end'
      }
    },
    noHeaderLogo: {
      marginBottom: '0px!important',
      transform: 'inherit!important'
    },
    offline: {
      '& >* ': {
        opacity: 0.5
      }
    }

  }

  return classList
})

export default function CardSkelaton ({ fullWidth, ...props }) {
  const classes = useStyles()
  return (
    <Card elevation={2} className={classnames(classes.card, fullWidth ? classes.fullWidth : null)} >
    <Skeleton variant="rect" height={100} />
    <CardContent style={{ paddingBottom: 0 }}>
      <div className={classes.cardHeader}>
        <Skeleton variant="circular" width={80} height={80} />
        <Skeleton variant="text" height={50}  width='100%'/>
      </div>

      <Skeleton variant="text" width="50%" height={30} />
      <Skeleton variant="text" width="60%" height={30} />
      <div className={classes.footer}>
        <div className="start">
          <Skeleton variant="text" height={30} />
        </div>
        <div className="center">
          <Skeleton variant="text" height={30} />
        </div>
        <div className="end">
          <Skeleton variant="text" height={30} />
        </div>
      </div>
    </CardContent>
  </Card>
  )
}
